import service from '@api/config'

// 筛选条件查询找活干列表
export const findJobList = (data) => {
  return service.request({
    url: `/pc/project/list`,
    method: 'post',
    data: data
  })
}
// 根据找活id查询找活详情
export const assignTaskDetail = (data) => {
  return service.request({
    url: `/assignTask/detail`,
    method: 'post',
    data: data
  })
}
// 获取身份当前默认找活信息
export const findJobInit = (data) => {
  return service.request({
    url: `/recruit/worker/info`,
    method: 'post',
    data: data
  })
}

// 查询是否包含敏感词
export const illegalWordsCheck = (data) => {
  return service.request({
    url: `/common/illegalWordsCheck`,
    method: 'post',
    data: data
  })
}

// 发布找活广告
export const findJobPublish = (data) => {
  return service.request({
    url: `/recruit/worker/publish`,
    method: 'post',
    data: data
  })
}
// 查看已发布的信息
export const findJobFindJob = (data) => {
  return service.request({
    url: `/findJob/history`,
    method: 'post',
    data: data
  })
}
// 删除已发布的找活广告信息
export const findJobDelete = (data) => {
  return service.request({
    url: `/findJob/delete`,
    method: 'post',
    data: data
  })
}

// 招工信息推荐 参数// cityCode
export const recommendProjects = (data) => {
  return service.request({
    url: `/pc/projects/recommend`,
    method: 'post',
    data: data
  })
}

// 招工信息推荐(详情内) 参数// id
export const recommendProjectsForDetail = (data) => {
  return service.request({
    url: `/pc/project/detail/recommend`,
    method: 'post',
    data: data
  })
}

